import { t } from "i18next";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import phBag from "../../../assets/images/blurred2/wishes/bag.webp";
import phCar from "../../../assets/images/blurred2/wishes/car.webp";
import phHouse from "../../../assets/images/blurred2/wishes/house.webp";
import phJuice from "../../../assets/images/blurred2/wishes/juice_glass.webp";
import phRing from "../../../assets/images/blurred2/wishes/ring.webp";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url, isValidArray, nextPageRoute } from "../../../utils/modules";

const buttonText = [
  t("special_achievement.options.buy_house"),
  t("special_achievement.options.perfect_wedding"),
  t("special_achievement.options.vacation"),
  t("special_achievement.options.buy_car"),
  t("special_achievement.options.retirement"),
];

const data = [
  {
    image: addS3Url("/wishes/house.png"),
    placeHolderImage: phHouse,
  },
  {
    image: addS3Url("/wishes/ring.png"),
    placeHolderImage: phRing,
  },
  {
    image: addS3Url("/wishes/bag.png"),
    placeHolderImage: phBag,
  },
  {
    image: addS3Url("/wishes/car.png"),
    placeHolderImage: phCar,
  },
  {
    image: addS3Url("/wishes/juice_glass.png"),
    placeHolderImage: phJuice,
  },
];

const WishToAchieve = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [selectedJobs, setSelectedJobs] = useState([]);

  const toggleJobSelection = (job) => {
    if (selectedJobs.includes(job)) {
      setSelectedJobs(
        selectedJobs.filter((selectedJob) => selectedJob !== job)
      );
    } else {
      setSelectedJobs([...selectedJobs, job]);
    }
  };

  const isSelected = (job) => {
    return selectedJobs.includes(job)
      ? "job-selected-button"
      : "job-select-button";
  };

  return (
    <MobileViewLayout>
      <div className="flex-grow-1 px-4">
        <h1
          className="fs30 fw-bold text-center incomesLab-selection-heading"
          style={{ paddingTop: "25px", paddingBottom: "20px" }}
        >
          <Trans
            i18nKey={"special_achievement.question"}
            components={{ tag: <br /> }}
          />
        </h1>
        <div className="w-100 d-flex flex-column">
          {data.map((item, index) => (
            <SelectOption
              key={index}
              toggleJobSelection={toggleJobSelection}
              isSelected={isSelected}
              label={buttonText[index]}
              {...item}
            />
          ))}
        </div>
        <Button
          onClick={() =>
            isValidArray(selectedJobs) &&
            nextPageRoute(navigate, `/${params.gender}/timespending`)
          }
          className="w-100 fw-bold fs18 bgSecondary sticky-button"
          style={{
            marginTop: "18px",
            marginBottom: "18px",
            padding: "15px 0px",
            height: "60px",
          }}
        >
          <Trans i18nKey={"common_text.continue"} />
        </Button>
      </div>
    </MobileViewLayout>
  );
};

export default WishToAchieve;

const SelectOption = ({
  label,
  image,
  isSelected,
  toggleJobSelection,
  placeHolderImage,
}) => {
  return (
    <div
      tabIndex="0"
      className={`my-2 rounded-2 d-flex justify-content-between align-items-center ${isSelected(
        label
      )}`}
      onClick={() => toggleJobSelection(label)}
    >
      <p
        className={`m-0 fw-bold income-slab-button-text wishes-button`}
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      >
        {label}
      </p>
      {image && (
        <div
          className="d-flex justify-content-center  align-content-center "
          style={{ height: "40px", width: "60px" }}
        >
          <ImageLoader
            placeHolderImage={placeHolderImage}
            src={image}
            alt="emoji"
            className="imgClass"
            style={{
              maxHeight: "40px",
              maxWidth: "60px",
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </div>
  );
};
